import type { Meta, StoryObj } from "@storybook/react";

import type { CounterProps } from "@/ui/core";
import { Counter } from "@/ui/core";

const StoryMeta: Meta<CounterProps> = {
  title: "Core/Counter",
  component: Counter,
  argTypes: {
    isActive: { control: "boolean" },
    number: { control: "number" },
    testID: { control: "text" },
  },
  args: {
    number: 4,
    testID: "storybook",
  },
};

type Story = StoryObj<CounterProps>;

const Primary: Story = {};

const IsActive: Story = {
  ...StoryMeta,
  args: {
    isActive: true,
  },
};

export { IsActive, Primary };
export default StoryMeta;
